(() => {
  function setup(root = document) {
    root.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const showMedia = id => {
        if (!id || !section.querySelector(`[data-media="${id}"]`)) return;
        section.querySelectorAll('[data-media]').forEach(el => {
          el.hidden = el.dataset.media !== id;
          if (el.hidden) el.querySelectorAll('video').forEach(v => v.pause());
        });
        section.querySelectorAll('[data-media-target]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.mediaTarget === id)));
      };
      section.querySelectorAll('[data-media-target]').forEach(b => b.addEventListener('click', () => showMedia(b.dataset.mediaTarget)));
      const select = section.querySelector('[data-variant-select]');
      select?.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const price = section.querySelector('[data-price]');
        if (price) {
          price.replaceChildren(document.createTextNode(option.dataset.price));
          if (option.dataset.compare) { const s = document.createElement('s'); s.textContent = option.dataset.compare; price.append(s); }
        }
        const buy = section.querySelector('[data-buy]');
        if (buy) { buy.disabled = option.dataset.available !== 'true'; buy.textContent = buy.disabled ? 'Ausverkauft' : buy.dataset.label; }
        showMedia(option.dataset.media);
        const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
      });
    });
  }
  setup();
  document.addEventListener('shopify:section:load', e => setup(e.target));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') document.querySelectorAll('header details[open]').forEach(d => { d.open = false; d.querySelector('summary')?.focus(); }); });
  document.addEventListener('click', e => {
    document.querySelectorAll('header details[open]').forEach(d => { if (!d.contains(e.target)) d.open = false; });
    if (e.target.closest('.mobile-menu a')) document.querySelectorAll('.mobile-menu[open]').forEach(d => d.open = false);
  });
})();
